export default function (Site, $) {
  Site.widget('pageLoadIndicator', {
    _create () {
      let timer
      Site.on('xhrLoadStart', () => {
        this.element.attr('state', '')
        clearTimeout(timer)
        timer = setInterval(() => {
          this.element.attr('state', 'loading')
        }, 10)
      })
      Site.on('xhrTransitioningOut', () => {
        clearTimeout(timer)
        this.element.attr('state', 'nearly')
      })
      Site.on('xhrWillTransitionWidgetsIn', () => {
        clearTimeout(timer)
        this.element.attr('state', 'ready')
        timer = setTimeout(() => {
          this.element.attr('state', '')
        }, 600)
      })
    },

    _transitionIn () {
      var url = window.location.href;
      
      if (url.search("#") >= 0) {
        var stickyHeaderHeight = document.getElementsByClassName("sticky-header")[0].clientHeight;
        document.documentElement.scrollTop = document.documentElement.scrollTop - stickyHeaderHeight;
      } 
      
    },
  })
}